import React from "react";
import { ScheduleComparison } from "../../../models/ScheduleComparison";
import "./Scorecard.scss";

export default function CaveatsBanner({ comparison }: { comparison: ScheduleComparison }) {
  if (comparison.comparable) {
    return <div className="scorecard-caveats ok">Apples-to-apples ✓ — the run and final schedule cover the same work.</div>;
  }
  return (
    <div className="scorecard-caveats warning">
      <strong>⚠ Read with care — these differ between the run and the final schedule:</strong>
      <ul>{comparison.caveats.map((c, i) => <li key={i}>{c.message}</li>)}</ul>
    </div>
  );
}
